/*
 * Author: harper
 * File Created: Saturday, 23-10-07 11:52 am
 * Last Modified: Tuesday, 25-06-17 06:28 pm, by Ben Zhao
 * Copyright © 2023 - wello wallet MIT
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
function ArrowForward(props?: {
  fill?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="ArrowForward" data-sentry-source-file="index.tsx">
      <path d="M9.02044 5.3637C9.37191 5.01223 9.94176 5.01223 10.2932 5.3637L15.9501 11.0206C16.3016 11.372 16.3016 11.9419 15.9501 12.2933L10.2932 17.9502C9.94176 18.3017 9.37191 18.3017 9.02044 17.9502C8.66897 17.5987 8.66897 17.0289 9.02044 16.6774L14.0409 11.657L9.02044 6.63649C8.66897 6.28502 8.66897 5.71517 9.02044 5.3637Z" fill={props?.fill || 'currentColor'} data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default ArrowForward;